import { CareMembershipStatus } from '@televet/shared-types/care/enums/CareMembershipStatus';

export const careMembershipStatusOptions = [
  { label: 'Active', value: CareMembershipStatus.Active },
  { label: 'Never Enrolled', value: CareMembershipStatus.NeverEnrolled },
  { label: 'Canceled', value: CareMembershipStatus.Canceled },
];
